import { Injectable } from '@angular/core';
import { GridCell, RendererType, RowCell } from '@urbannex/storethemes';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';

@Injectable({
  providedIn: 'root'
})
export class ElementSelectorService {

  constructor(private previewEditStoreService:PreviewEditStoreService) { }
  /**
   * 
   * @param selectedCell The selected Cell Object
   * @param renderedPreview The Html Element Containing the collection of cells
   * @returns selectedCelEl
   */
  resolveSelectedCell(selectedCell:GridCell | RowCell,renderedPreview:HTMLElement):HTMLElement{
    console.log(selectedCell,renderedPreview)
    let selectedCelEl:HTMLElement;
    let cellWrapper;
    this.previewEditStoreService.selectedSection$.subscribe(section => {
      console.log(section);
      let rendererType = section.rendererType;
      if((rendererType).includes(".")){
        let enumKey = rendererType.split('.')[1] as keyof typeof RendererType;
        rendererType = RendererType[enumKey];
      }
      switch (rendererType) {
        case RendererType.BANNER:
        case "banner":
          cellWrapper = "KW-BANNER-WRAPPER"  
          break;
        case RendererType.GRID:
        case "grid":
            cellWrapper = "KW-GRID-CELL-WRAPPER"  
            break;
      
        default:
          break;
      }
    })
    console.log(cellWrapper);
    let rendererContentCells = renderedPreview.querySelectorAll(cellWrapper);
    console.log(rendererContentCells)
    if(rendererContentCells){
      rendererContentCells.forEach((rendererContentCell:HTMLElement) => {
        let cellIdAttr = rendererContentCell.getAttribute("cell-id");
        if(cellIdAttr && cellIdAttr == selectedCell.cellId){
          selectedCelEl = rendererContentCell;
        }
      })
    }
    return selectedCelEl
  }
}
